import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import DriverService from "services/driver.service";
import ComboBoxRedux from "components/molecules/ComboBoxRedux";
import PrivilegeService from "utils/privilege.util";

export default function SelectDriver(props: any) {
	const driverOptions = useAppSelector(
		(state) => state.driver.driverOptions
	);
	const permissions = useAppSelector((state) => state.auth?.user?.role_id?.permissions);


	useEffect(() => {
		if (PrivilegeService.checkPrivilege("driver:read", permissions)) {
			let partner_id = process.env.REACT_APP_ENV === "Production" ? "63ea0b28c32eebbb57a7cc5e" : "64fb1c9937a2a1b4fa9b908a"
			DriverService.getPartnerDrivers(partner_id);
		}
	}, []);

	return <ComboBoxRedux {...props} options={driverOptions} />;
}
